import { render } from "./AddCategory.vue?vue&type=template&id=d0d491ec&scoped=true&ts=true"
import script from "./AddCategory.vue?vue&type=script&lang=ts"
export * from "./AddCategory.vue?vue&type=script&lang=ts"

import "./AddCategory.vue?vue&type=style&index=0&id=d0d491ec&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d491ec"]])

export default __exports__